import React, { useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import Table from "../../../core/common/dataTable/index";
import ProfileTab from "../../../core/common/profiletab";
import { HTMLAriaDataAttributes } from "antd/es/_util/aria-data-attrs";
import Swal from "sweetalert2";
import useApi from "../../../core/customhook/useApi";

const Langauge = () => {
  const routes = all_routes;
  const {
    data: onboardingstatus,
    loading: onboardingstatusLoading,
    error: onboardingstatusError,
  } = useApi("/api/onboarding/final-status", {
    method: "GET",
    autoCall: true,
  });

  const status = onboardingstatus?.data?.onb_status;
  const [callData, setCallData] = useState(1);
  const [editData, setEditData] = useState<any>({});

  const columns1 = [
    {
      title: "S. No.",
      dataIndex: "sno",
    },
    {
      title: "Language",
      dataIndex: "language",
    },
    {
      title: "Read",
      dataIndex: "read",
    },
    {
      title: "Write",
      dataIndex: "write",
    },
    {
      title: "Speak",
      dataIndex: "speak",
    },
    {
      title: "Primary Language",
      dataIndex: "primary_language",
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_: any, record: any) => {
        const canEdit =
          status === "In Progress" ||
          status === "Rejected" ||
          status === "Re Open" || 
          status === "Not Started";

        return (
          <i
            className={`ti ti-edit ${canEdit ? "text-primary" : "text-secondary"}`}
            style={{
              cursor: canEdit ? "pointer" : "not-allowed",
              opacity: canEdit ? 1 : 0.5,
            }}
            title={
              canEdit
                ? "Edit"
                : "Editing is only allowed when status is In Progress, Rejected, or Re Open"
            }
            onClick={() => {
              if (canEdit) {
                setEditData(record);
              }
            }}
            data-bs-toggle={canEdit ? "modal" : undefined}
            data-bs-target={canEdit ? "#editexampleModalLg" : undefined}
          />
        );
      },
    }

  ];
  const [data, setData] = useState({
    language: "",
    read: "",
    write: "",
    speak: "",
    primary_language: "",
  });

  const getEditData = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  const getInputData = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>
  ) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const {
    data: langaugeData,
    loading: langaugeLoading,
    error: langaugeError,
  } = useApi("/api/onboarding/view-language-profiency", {
    method: "GET",
    autoCall: true,
    dependencies: [callData],
  });

  const addSNo = langaugeData?.data?.map((item: any, index: any) => {
    return {
      ...item,
      sno: index + 1,
    };
  });

  const {
    data: Langauge,
    loading,
    error,
    callApi: postLangauge,
  } = useApi("/api/onboarding/add-language-profiency", {
    method: "POST",
    autoCall: false,
  });

  const postData = async (e: React.FormEvent<HTMLFormElement>) => {
    console.log(data);
    e.preventDefault();
    try {
      const response = await postLangauge(data);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "Data submitted successfully!",
          confirmButtonColor: "#3085d6",
        }).then(() => {
          document.getElementById("closeModalBtn")?.click();
        });
        setCallData(callData + 1);
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text:
          error?.response?.data?.message ||
          "Something went wrong while submitting the form.",
        confirmButtonColor: "#d33",
      });
    }
  };

  const {
    data: langaugeEditData,
    loading: langaugeEditLoading,
    error: langaugeEditError,
    callApi: editLangaugeData,
  } = useApi("/api/onboarding/edit-language-profiency", {
    method: "POST",
    autoCall: false,
  });

  const handleEdit = async (e: any) => {
    e.preventDefault();
    try {
      const payload = {
        ...editData,
        language_id: editData.ID,
      };
      console.log(payload);
      const response = await editLangaugeData(payload);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "Data submitted successfully!",
          confirmButtonColor: "#3085d6",
        }).then(() => {
          document.getElementById("editcloseModalBtn")?.click();
        });
        setCallData(callData + 1);
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text:
          error?.response?.data?.message ||
          "Something went wrong while submitting the form.",
        confirmButtonColor: "#d33",
      });
    }
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Langauge Proficiency</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Administration</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Langauge Proficiency
                  </li>
                </ol>
              </nav>
            </div>
            <div className="head-icons ms-2">
              <CollapseHeader />
            </div>
          </div>
          <div className="row">
            <div className="col-xl-3 theiaStickySidebar">
              <div
                className="stickybar"
                style={{ position: "sticky", top: "50px" }}
              >
                <ProfileTab />
              </div>
            </div>
            <div className="col-xl-9">
              <div className="card">
                <div className="card-body d-flex justify-content-between">
                  <div>
                    <h4>Langauge Proficiency</h4>
                  </div>
                  {
                    status === "In Progress" || status === "Rejected" || status === "Re Open" || status === "Not Started" ? <button
                      className="btn btn-primary custom_button"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModalLg"
                    >
                      {" "}
                      <i className="ti ti-circle-plus me-2" />
                      Add New Langauge
                    </button> : ""
                  }

                </div>
                <div className="card">
                  <Table
                    dataSource={addSNo || []}
                    columns={columns1}
                    Selection={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModalLg"
        tabIndex={-1}
        aria-labelledby="exampleModalLgLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLgLabel">
                Language Proficiency
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeModalBtn"
              />
            </div>
            <div className="modal-body">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={postData}>
                    <div className="border-bottom mb-3">
                      <div className="row">
                        {/* Language Name */}
                        <div className="col-md-12">
                          <div className="row align-items-start mb-3">
                            <div className="col-xxl-2 col-md-3">
                              <label className="form-label mb-md-0">
                                Language<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-xxl-10 col-md-9">
                              <select
                                className="form-select"
                                name="language"
                                onChange={getInputData}
                                required
                              >
                                <option value="">Select Language</option>
                                <option value="English">English</option>
                                <option value="Spanish">Spanish</option>
                                <option value="Hindi">Hindi</option>
                                <option value="French">French</option>
                                <option value="Other">Other</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        {/* Read */}
                        <div className="col-md-12">
                          <div className="row align-items-start mb-3">
                            <div className="col-xxl-2 col-md-3">
                              <label className="form-label mb-md-0">
                                Read<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-xxl-10 col-md-9">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="read"
                                  id="readYes"
                                  value="Yes"
                                  onChange={getInputData}
                                  required
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="readYes"
                                >
                                  Yes
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="read"
                                  id="readNo"
                                  value="No"
                                  onChange={getInputData}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="readNo"
                                >
                                  No
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Write */}
                        <div className="col-md-12">
                          <div className="row align-items-start mb-3">
                            <div className="col-xxl-2 col-md-3">
                              <label className="form-label mb-md-0">
                                Write<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-xxl-10 col-md-9">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="write"
                                  id="writeYes"
                                  value="Yes"
                                  onChange={getInputData}
                                  required
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="writeYes"
                                >
                                  Yes
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="write"
                                  id="writeNo"
                                  value="No"
                                  onChange={getInputData}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="writeNo"
                                >
                                  No
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Speak */}
                        <div className="col-md-12">
                          <div className="row align-items-start mb-3">
                            <div className="col-xxl-2 col-md-3">
                              <label className="form-label mb-md-0">
                                Speak<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-xxl-10 col-md-9">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="speak"
                                  id="speakYes"
                                  value="Yes"
                                  onChange={getInputData}
                                  required
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="speakYes"
                                >
                                  Yes
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="speak"
                                  id="speakNo"
                                  value="No"
                                  onChange={getInputData}
                                  required
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="speakNo"
                                >
                                  No
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Primary Language */}
                        <div className="col-md-12">
                          <div className="row align-items-start mb-3">
                            <div className="col-xxl-2 col-md-3">
                              <label className="form-label mb-md-0">
                                Primary<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-xxl-10 col-md-9">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="primary_language"
                                  id="primaryYes"
                                  value="Yes"
                                  onChange={getInputData}
                                  required
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="primaryYes"
                                >
                                  Yes
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="primary_language"
                                  id="primaryNo"
                                  value="No"
                                  onChange={getInputData}
                                  required
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="primaryNo"
                                >
                                  No
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="d-flex align-items-center justify-content-end">
                      <button
                        type="button"
                        className="btn btn-outline-light border me-3"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary custom_button">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="editexampleModalLg"
        tabIndex={-1}
        aria-labelledby="exampleModalLgLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLgLabel">
                Edit Language Proficiency
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="editcloseModalBtn"
              />
            </div>
            <div className="modal-body">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleEdit}>
                    <div className="border-bottom mb-3">
                      <div className="row">
                        {/* Language Name */}
                        <div className="col-md-12">
                          <div className="row align-items-start mb-3">
                            <div className="col-xxl-2 col-md-3">
                              <label className="form-label mb-md-0">
                                Language<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-xxl-10 col-md-9">
                              <select
                                className="form-select"
                                name="language"
                                value={editData.language}
                                onChange={getEditData}
                                disabled
                                required
                              >
                                <option value="">Select Language</option>
                                <option value="English">English</option>
                                <option value="Spanish">Spanish</option>
                                <option value="Hindi">Hindi</option>
                                <option value="French">French</option>
                                <option value="Other">Other</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        {/* Read */}
                        <div className="col-md-12">
                          <div className="row align-items-start mb-3">
                            <div className="col-xxl-2 col-md-3">
                              <label className="form-label mb-md-0">
                                Read<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-xxl-10 col-md-9">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="read"
                                  id="readYes"
                                  value="Yes"
                                  checked={editData.read === "Yes"}
                                  onChange={getEditData}
                                  required
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="readYes"
                                >
                                  Yes
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="read"
                                  id="readNo"
                                  value="No"
                                  checked={editData.read === "No"}
                                  onChange={getEditData}
                                  required
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="readNo"
                                >
                                  No
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Write */}
                        <div className="col-md-12">
                          <div className="row align-items-start mb-3">
                            <div className="col-xxl-2 col-md-3">
                              <label className="form-label mb-md-0">
                                Write<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-xxl-10 col-md-9">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="write"
                                  id="writeYes"
                                  value="Yes"
                                  checked={editData.write === "Yes"}
                                  onChange={getEditData}
                                  required
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="writeYes"
                                >
                                  Yes
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="write"
                                  id="writeNo"
                                  value="No"
                                  checked={editData.write === "No"}
                                  onChange={getEditData}
                                  required
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="writeNo"
                                >
                                  No
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Speak */}
                        <div className="col-md-12">
                          <div className="row align-items-start mb-3">
                            <div className="col-xxl-2 col-md-3">
                              <label className="form-label mb-md-0">
                                Speak<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-xxl-10 col-md-9">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="speak"
                                  id="speakYes"
                                  value="Yes"
                                  checked={editData.speak === "Yes"}
                                  onChange={getEditData}
                                  required
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="speakYes"
                                >
                                  Yes
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="speak"
                                  id="speakNo"
                                  value="No"
                                  checked={editData.speak === "No"}
                                  onChange={getEditData}
                                  required
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="speakNo"
                                >
                                  No
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Primary Language */}
                        <div className="col-md-12">
                          <div className="row align-items-start mb-3">
                            <div className="col-xxl-2 col-md-3">
                              <label className="form-label mb-md-0">
                                Primary<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-xxl-10 col-md-9">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="primary_language"
                                  id="primaryYes"
                                  value="Yes"
                                  checked={editData.primary_language === "Yes"}
                                  onChange={getEditData}
                                  required
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="primaryYes"
                                >
                                  Yes
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="primary_language"
                                  id="primaryNo"
                                  value="No"
                                  checked={editData.primary_language === "No"}
                                  onChange={getEditData}
                                  required
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="primaryNo"
                                >
                                  No
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="d-flex align-items-center justify-content-end">
                      <button
                        type="button"
                        className="btn btn-outline-light border me-3"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Langauge;
